module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerWrapper"
  }, [_c('header', {
    ref: "header",
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Apijs\n      ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/list"
    }
  }, [_vm._v("接口\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/docs"
    }
  }, [_vm._v("文档\n          ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7655c773!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 97
// module chunks = 1